import useTWScreens from '@/hooks/ui/useTWScreens';
import { cn } from '@/lib/utils';
import type { PopUpVariant } from './PagePopup';
import type { ReactNode } from 'react';
interface PopupMediaProps {
  children: ReactNode;
  className?: string;
  variant?: PopUpVariant;
  videoAspectRatio?: number;
}
export const PopupMedia = ({
  className,
  children,
  variant = 'default',
  videoAspectRatio
}: PopupMediaProps) => {
  const {
    isMd
  } = useTWScreens();
  if (variant === 'mobile-banner-image') {
    return <div className="relative h-full w-auto">{children}</div>;
  }
  return <div className={cn('relative h-auto',
  // Desktop widths
  isMd && variant === 'default' && 'w-[298px] overflow-hidden rounded-lg', isMd && variant === 'banner-img-pu' && 'w-[360px]',
  // Mobile width
  !isMd && 'w-full', !isMd && variant === 'default' && 'overflow-hidden rounded-lg', className)} style={{
    aspectRatio: videoAspectRatio ?? 298 / 160
  }} data-sentry-component="PopupMedia" data-sentry-source-file="PopupMedia.tsx">
      {children}
      {variant === 'banner-img-pu' && <div className="absolute inset-0 h-12 bg-gradient-to-b from-black/50 to-transparent" />}
    </div>;
};